import React, {useContext} from "react";
import {IPageClickEvent, IPageViewEvent} from "./utils";

interface AmplitudeContextProps {
  pageClickEvent: ({page, cta, data}: IPageClickEvent) => void;
  pageViewEvent: ({page, data, user_step}: IPageViewEvent) => void;
  setError: (error: string | undefined) => void;
}

const AmplitudeContext = React.createContext<AmplitudeContextProps>(undefined!);

const useAmplitude = (): AmplitudeContextProps => {
  const context = useContext(AmplitudeContext);

  if (!context) throw new Error("AmplitudeContext must be used inside AmplitudeProvider");

  return context;
};

export {AmplitudeContext, useAmplitude};
export type {AmplitudeContextProps};
